import * as React from "react";
const SvgFiRrFootball = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-football_svg__a)">
      <path d="M12.003-.002C5.365-.002-.016 5.379-.016 12.017c0 6.637 5.381 12.018 12.019 12.018s12.019-5.38 12.019-12.018S18.64-.002 12.002-.002m7.449 8.84.776-2.509a9.94 9.94 0 0 1 1.745 5.131L19.83 9.951a1 1 0 0 1-.38-1.113M14.6 2.353h-.008l-2 1.456a1 1 0 0 1-1.176 0l-2-1.456a9.7 9.7 0 0 1 5.184 0M3.772 6.33l.776 2.508a1 1 0 0 1-.38 1.113l-2.141 1.51a9.94 9.94 0 0 1 1.745-5.13m.235 11.654 2.747.01a1 1 0 0 1 .95.693l.864 2.693a10.03 10.03 0 0 1-4.561-3.396m11.426 3.396.863-2.693a1 1 0 0 1 .949-.694l2.748-.009a10.02 10.02 0 0 1-4.56 3.396m5.736-5.4-3.93.013a2.99 2.99 0 0 0-2.847 2.084l-1.235 3.85a9.2 9.2 0 0 1-2.314 0l-1.235-3.85a2.99 2.99 0 0 0-2.848-2.084l-3.93-.012a10 10 0 0 1-.658-2.176l3.149-2.219a2.99 2.99 0 0 0 1.138-3.338L5.324 4.576a10 10 0 0 1 1.884-1.349l3.028 2.2a2.99 2.99 0 0 0 3.528 0l3.028-2.2c.678.376 1.31.828 1.884 1.35L17.54 8.247a2.99 2.99 0 0 0 1.138 3.338l3.149 2.22a10 10 0 0 1-.66 2.174" />
      <path d="M15.386 9.224 13.47 7.832a2.49 2.49 0 0 0-2.938 0L8.614 9.224a2.49 2.49 0 0 0-.908 2.8l.732 2.253A2.49 2.49 0 0 0 10.815 16h2.37a2.5 2.5 0 0 0 2.378-1.728l.731-2.253a2.49 2.49 0 0 0-.908-2.795m-.994 2.177-.73 2.253a.5.5 0 0 1-.477.346h-2.37a.5.5 0 0 1-.475-.346L9.608 11.4a.5.5 0 0 1 .182-.56l1.916-1.39a.5.5 0 0 1 .588 0l1.917 1.392a.5.5 0 0 1 .181.559" />
    </g>
    <defs>
      <clipPath id="fi-rr-football_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFootball;
